module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAUCAYAAACXtf2DAAABLUlEQVQ4jbXUMUvDYBDG8Z+2Y4dWBF0LTm6Cogg6OBRBrXQSHNRBHB1U/BzufgJBEBx0F8HBTRAHXQUXt4IgWh2SYA1Nk9T6wBFyuXv+d3nhLUjXFkbxlKE2t+r4wuZ/mC/gIwQs9WoymJCv4xKFlLqeVMOnYPIopns1K8TeGzhDMZavCg66iCbeeoHV0PJ78k7xiiPM5TFv4D2DeTxOMZZmvpZx8qR4wUo3wNUfzNtjPwlQxUOfIHtJkApu+gRZToKM9GmTZ5Qi04EOm1xgJpY/xG34vRQ+pwRXSKXDsMfY6bbJfWyq2YTaYWzgPFbfwkQSAMq4luG/tmlSsH3Uc5LWMOxnk3oGQKSDsKeJobTiMh6xnQMAqyFkN37InTQuuOTuckLWsZizJ7fmvwGwI53chr1UcQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/mobile/back-btn.png
// module id = kj+x
// module chunks = 1